"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThumbDown = function ThumbDown(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M8 6H6V14H8V6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.8333 11C16.8333 11.2652 16.728 11.5196 16.5404 11.7071C16.3529 11.8946 16.0986 12 15.8333 12C16.0986 12 16.3529 12.1054 16.5404 12.2929C16.728 12.4804 16.8333 12.7348 16.8333 13C16.8333 13.2652 16.728 13.5196 16.5404 13.7071C16.3529 13.8946 16.0986 14 15.8333 14H14V18C14 18.5304 13.7893 19.0391 13.4142 19.4142C13.0391 19.7893 12.5304 20 12 20V18C12 16.9391 11.5786 15.9217 10.8284 15.1716C10.0783 14.4214 9.06087 14 8 14V7H9.10156C9.27697 6.69591 9.52938 6.44339 9.83339 6.26784C10.1374 6.09229 10.4823 5.99991 10.8333 6H15.8333C16.0986 6 16.3529 6.10536 16.5404 6.29289C16.728 6.48043 16.8333 6.73478 16.8333 7C16.8333 7.26522 16.728 7.51957 16.5404 7.70711C16.3529 7.89464 16.0986 8 15.8333 8C16.0986 8 16.3529 8.10536 16.5404 8.29289C16.728 8.48043 16.8333 8.73478 16.8333 9C16.8333 9.26522 16.728 9.51957 16.5404 9.70711C16.3529 9.89464 16.0986 10 15.8333 10C16.0986 10 16.3529 10.1054 16.5404 10.2929C16.728 10.4804 16.8333 10.7348 16.8333 11Z",
    fill: props.foregroundColor
  }));
};

ThumbDown.defaultProps = {
  altText: "Thumb Down",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
ThumbDown.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = ThumbDown;
exports.default = _default;